import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import DuplicateIcon from '@heroicons/react/outline/DuplicateIcon';
import { PlanName, StoreItemStanding, StoreItemStatus, TemplateEntityType, } from '@tribeplatform/gql-client/types';
import { useCreateTemplate, useUpdateTemplate, } from '@tribeplatform/react-sdk/hooks';
import { Accordion } from '@tribeplatform/react-ui-kit/Accordion';
import { Alert } from '@tribeplatform/react-ui-kit/Alert';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Container } from '@tribeplatform/react-ui-kit/Layout';
import { Modal } from '@tribeplatform/react-ui-kit/Modal';
import { toast } from '@tribeplatform/react-ui-kit/Toast';
import { Form } from '../../Form';
import { T, useI18n } from '../../i18n';
export const CreateSpaceTemplate = ({ open, space, template, onClose, }) => {
    const { $t } = useI18n();
    const isNew = !(template === null || template === void 0 ? void 0 : template.id);
    const { mutateAsync: createTemplate, isLoading: isCreating } = useCreateTemplate();
    const { mutateAsync: updateTemplate, isLoading: isUpdating } = useUpdateTemplate();
    const onSubmit = async ({ name, slug, description, image, entityProperties, requiredPlan, }) => {
        const input = {
            name,
            slug,
            description,
            imageId: image === null || image === void 0 ? void 0 : image.id,
            entityProperties,
            requiredPlan,
        };
        if (isNew || template.standing === StoreItemStanding.REGULAR) {
            delete input.slug;
        }
        if (isNew) {
            return createTemplate({
                input: {
                    ...input,
                    ...{
                        entityId: space === null || space === void 0 ? void 0 : space.id,
                        entityType: TemplateEntityType.Space,
                    },
                },
            }).then(() => {
                onClose();
                toast({
                    title: $t({
                        id: 'Space.Template.Created',
                        defaultMessage: '{SPACE_CC} template created',
                    }),
                    description: $t({
                        id: 'Space.Template.Created.Description',
                        defaultMessage: 'Your new {SPACE} template is ready to be used.',
                    }),
                });
            });
        }
        return updateTemplate({
            id: template === null || template === void 0 ? void 0 : template.id,
            input,
        }).then(() => {
            onClose();
            toast({
                title: $t({
                    id: 'Space.Template.Updated',
                    defaultMessage: '{SPACE_CC} template updated',
                }),
                description: $t({
                    id: 'Space.Template.Updated.Description',
                    defaultMessage: '{SPACE_CC} template was updated successfully.',
                }),
            });
        });
    };
    return (_jsxs(Modal, { open: open, onClose: onClose, children: [_jsx(Modal.Header, { title: (template === null || template === void 0 ? void 0 : template.id)
                    ? $t({
                        id: 'Space.Template.Update.Title',
                        defaultMessage: 'Update {SPACE} template',
                    })
                    : $t({
                        id: 'Space.Template.Create.Title',
                        defaultMessage: 'Create {SPACE} template',
                    }) }, void 0), _jsx(Modal.Content, { children: _jsx(Form, { onSubmit: onSubmit, defaultValues: template || {}, children: _jsxs(Container, { size: "full", spacing: "sm", children: [isNew && (_jsx(Alert, { status: "neutral", title: $t({
                                    id: 'Space.Template.CreatingFromSpace',
                                    defaultMessage: 'Creating template from {space_name}',
                                }, { space_name: space === null || space === void 0 ? void 0 : space.name }), icon: _jsx(DuplicateIcon, {}, void 0), children: _jsx(T, { id: "Space.Template.CreatingFromSpace.Description", defaultMessage: "You will be able to create a new {SPACE} based on this template" }, void 0) }, void 0)), _jsx(Form.Input, { name: "name", label: $t({
                                    id: 'Generics.Name.Noun',
                                    defaultMessage: 'Name',
                                }) }, void 0), !isNew && template.status === StoreItemStatus.PUBLIC && (_jsxs(_Fragment, { children: [_jsx(Form.Input, { name: "slug", label: $t({
                                            id: 'Generics.Slug',
                                            defaultMessage: 'Slug',
                                        }) }, void 0), _jsx(Form.Select, { name: "requiredPlan", label: $t({
                                            id: 'Space.Template.RequiredPlanLabel',
                                            defaultMessage: 'Required plan',
                                        }), items: [
                                            PlanName.Basic,
                                            PlanName.Premium,
                                            PlanName.Advanced,
                                            PlanName.Enterprise,
                                        ].map(plan => ({ text: plan, value: plan })) }, void 0)] }, void 0)), _jsx(Form.Textarea, { name: "description", label: $t({
                                    defaultMessage: 'Description',
                                    id: 'Generics.Description',
                                }) }, void 0), _jsx(Form.Image, { multiple: false, name: "image", variant: "compact", label: $t({
                                    id: 'Generics.Preview.Noun',
                                    defaultMessage: 'Preview',
                                }) }, void 0), _jsxs(Accordion, { variant: "plus", iconAlign: "trailing", className: "-mx-2", children: [_jsx(Accordion.Button, { children: _jsx(T, { id: "Generics.AdvancedOptions", defaultMessage: "Advanced options" }, void 0) }, void 0), _jsx(Accordion.Panel, { children: _jsx(Form.Textarea, { name: "entityProperties", label: $t({
                                                id: 'Space.Template.EntityProperties',
                                                defaultMessage: 'Entity properties',
                                            }) }, void 0) }, void 0)] }, void 0), _jsxs(Form.Actions, { children: [_jsx(Button, { type: "submit", size: "lg", loading: isCreating || isUpdating, children: isNew ? (_jsx(T, { id: "Space.Template.Actions.Create", defaultMessage: "Create template" }, void 0)) : (_jsx(T, { id: "Space.Template.Actions.Update", defaultMessage: "Update template" }, void 0)) }, void 0), _jsx(Button, { onClick: onClose, variant: "outline", size: "lg", children: _jsx(T, { id: "Generics.Cancel", defaultMessage: "Cancel" }, void 0) }, void 0)] }, void 0)] }, void 0) }, void 0) }, void 0)] }, void 0));
};
//# sourceMappingURL=index.js.map